import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19 20.75a.75.75 0 0 0 .75-.75V4a.75.75 0 0 0-.75-.75H5a.75.75 0 0 0-.75.75v16c0 .414.336.75.75.75zm-5.561-9.358a.75.75 0 0 1 .17 1.047l-1.143 1.584H14a.75.75 0 0 1 .605 1.193l-2 2.728a.75.75 0 0 1-1.21-.887l1.125-1.534H11a.75.75 0 0 1-.608-1.189l2-2.773a.75.75 0 0 1 1.047-.17M6 6h3v3H6zm7.5 3h-3V6h3zM15 9V6h3v3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }